import { Autocomplete, Button, Chip, InputLabel, TextField } from "@mui/material";
import React, { createContext, useCallback, useContext, useEffect, useMemo } from "react";
import { useImmer } from "use-immer";
import { extractUserDataFromPermission } from "../../../Utils/Utils";
import {
  FIXED_DROPDOWNS,
  FIXED_REACTIVE_DROPDOWNS_COF,
  disconnectionMemoIssuedDropdowns,
  failurStateToLabelMap,
  getAllowedUserRoleIds,
  getUserRoleDropdowns,
  rectificationStatusDropdowns,
  relayRoomOpenDropdowns,
} from "./Constants";
import { useGetDeviceTypesQuery, useGetDevicesNameQuery } from "../../../features/SearchFilters/searchFiltersSlice";
import { ActiveAlarmsData } from "../../Alarms/ActiveAlarms";
import {
  getDeviceNameSearchParams,
  getDeviceTypeSearchParams,
} from "../../../features/SearchFilters/searchFiltersUtils";
import {
  APP_BASE_URL,
  GET_ALL_USER,
  GET_ASSETS,
  GET_USER_LIST,
  GET_USER_ROLES,
  SFR_API,
} from "../../../Common/EndPoints";
import axios from "axios";
import { DateTimePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import TextareaAutosize from "@mui/base/TextareaAutosize";
import { styled } from "@mui/system";
import "./SFRFORM_Component.scss";
import AffectedGearTypes from "./Add AFFECTED GEAR TYPE  OR TRAIN/AffectedGearTypes";
import DetainedTrains from "./Add AFFECTED GEAR TYPE  OR TRAIN/DetainedTrains";
import dayjs from "dayjs";
import { Navigate, useNavigate } from "react-router-dom";
import ConfirmationModal from "../../../Modal/ConfirmationModal";
import moment from "moment";
import { toast } from "react-hot-toast";
import { min } from "rxjs";
import { getDesiredFormat, getDurationInMinutes, getMinMaxRangeOfDate } from "./Utils";
import { getLocalStorage } from "../../../Utils/storage-utils";

function hasDropdownCuurentValue(ddList, ddValue) {
  let hasValue = false;
  ddList.forEach((dd) => {
    if (dd.id === ddValue?.id) {
      hasValue = true;
    }
  });

  return hasValue;
}

const INITIAL_AFFECTED_ASSETS = [{ assetType: null, asset: null }];
const INITIAL_DETAINED_TRAINS = [{ trainNumber: null, detention: "", hqPunctality: "", rlyBdPunctuality: "" }];
function removeDependentStates(array, valuesToRemove) {
    return array.filter((value) => !valuesToRemove.includes(value));
}

function addDependentState(array, valuesToAdd) {
    valuesToAdd.forEach((value) => {
        if (!array.includes(value)) {
            array.push(value);
        }
    });

    return array;
}

const INITIAL_REQUIRED_FIELD = [
    "zone",
    "division",
    "customerId",
    'assetType',
    //"failureEntryNo",
    //'uimsNumber',
    "deviceId",
    "department",
    "deviceId",
    'failureOn',
    "infoReceivedBy",
    "infoReceivedTs",
    "status",
    "disconnectionMemoIssued",
    "relayRoomOpened",
];
let OCC_REQUIRED_FIELD = [
  "zone",
  "division",
  "customerId",
  "assetType",
  "deviceId",
  "department",
  "deviceId",
  "failureOn",
  // "uimsNumber",
];

const getInitalRequiredFields = (userRole) => {
    if (userRole === "DSTE") {
        return OCC_REQUIRED_FIELD;
    } else if (userRole === "OCC") {
        return OCC_REQUIRED_FIELD;
    }
    return INITIAL_REQUIRED_FIELD;
};

const shouldFieldShouldBeShownForRole = (role, fieldState) => {
    const stateObject = failurStateToLabelMap[fieldState];
    let shouldShowField = true;
    const removeForUserRoles = stateObject?.removeForUserRoles ?? null;
    if (removeForUserRoles) {
        if (removeForUserRoles.includes(role)) {
            shouldShowField = false;
        }
    }
    return shouldShowField;
};

const dependentRequiredFields = {
    status: ["failureAttendedTs", "repairedOn", "repairedBy", "causeOfFailure", "actionPerformed"],
    disconnectionMemoIssued: [
          "disconnectionMemoReqNumber",
          "disconnectionMemoTimeOfferd",
          "disconnectionMemoTimeAccepted",
          "gearDisconnectTime",
          "gearReconnectionTime",
    ],
    relayRoomOpened: ["relayRoomOpenTs", "relayRoomCloseTs"],
};
let initialConfirmationModal = {
    open: false,
    message: "",
    des: "",
};
function SFRFORM_Component({ initFaliureForm, isEdit }) {
  const USER_ROLE = getLocalStorage("authority");
  const [failureForm, setFailureForm] = useImmer(initFaliureForm); //getZoneList
  const [requiredFields, setRequiredFields] = useImmer(getInitalRequiredFields(USER_ROLE));
  const [confirmationModal, setConfirmationModal] = useImmer(initialConfirmationModal);
  const [validationState, setValidationState] = useImmer({ autoCheck: false });
  const navigate = useNavigate();
  let permissions = JSON.parse(localStorage.getItem("permissions"));
  const [isMakeModelExists, setIsMakeModelExists] = useImmer(true); //getZoneList
  const UESR_ROLE_DROPDOWNS = useMemo(() => getUserRoleDropdowns(), []);
  const allowedUserRoleIds = useMemo(() => getAllowedUserRoleIds(), []);

  const {
    outermostKeys: zone,
    outerToInnerKeys: division,
    innerToCustomerNames: station,
    customerNameToId: customer_name_to_id,
  } = extractUserDataFromPermission(permissions);
  const { customerIdList = [], selectedCustomersIdName = [] } = useContext(ActiveAlarmsData);
  const { data: gearTypesList = [] } = useGetDeviceTypesQuery(
    getDeviceTypeSearchParams({
      customerIdList,
      filterState: { customer_ids: failureForm?.customerId ? [failureForm?.customerId] : [] },
    }),
  );
  const { data: deviceNamesList = [] } = useGetDevicesNameQuery(
    getDeviceNameSearchParams({
      customerIdList,
      filterState: {
        customer_ids: failureForm?.customerId ? [failureForm?.customerId] : [],
        device_type_ids: failureForm?.assetType ? [failureForm?.assetType] : [],
      },
    }),
  );

  const handleChange = (stateName, value) => {
    setFailureForm((prev) => {
      prev[stateName] = value;
    });
  };
  useEffect(() => {
    if (validationState.autoCheck) {
      validateFailureForm(failureForm);
    }
  }, [failureForm]);
  // useEffect(() => {
  //     let dt = new Date();
  //     console.log("failureForm -- ", failureForm);
  //     setFailureForm((prev) => {
  //         prev.failureEntryNo = `FI-${failureForm.customerId ? failureForm.customerId.value : '<station>'}-${failureForm.department ? failureForm.department.value : '<department>'}-${dt.getTime()}`;
  //     });
  // }, [failureForm.customerId, failureForm.department]);
  useEffect(() => {
    let dependentFields = dependentRequiredFields.status;
    let existingRequiredFields = [...requiredFields];

    if (failureForm.status && (failureForm.status.value === "REPAIRED" || failureForm.status.value === "CLOSE")) {
      let newRequiredFields = addDependentState(existingRequiredFields, dependentFields);
      setRequiredFields(newRequiredFields);
    } else {
      let newRequiredFields = removeDependentStates(existingRequiredFields, dependentFields);
      setRequiredFields(newRequiredFields);
    }
  }, [failureForm.status]);

  useEffect(() => {
    let dependentFields = dependentRequiredFields.disconnectionMemoIssued;
    let existingRequiredFields = [...requiredFields];

    if (failureForm.disconnectionMemoIssued && failureForm.disconnectionMemoIssued.value === "YES") {
      let newRequiredFields = addDependentState(existingRequiredFields, dependentFields);
      setRequiredFields(newRequiredFields);
    } else {
      let newRequiredFields = removeDependentStates(existingRequiredFields, dependentFields);
      setRequiredFields(newRequiredFields);
    }
  }, [failureForm.disconnectionMemoIssued]);
  useEffect(() => {
    let dependentFields = dependentRequiredFields.relayRoomOpened;
    let existingRequiredFields = [...requiredFields];

    if (failureForm.disconnectionMemoIssued && failureForm.relayRoomOpened.value === "YES") {
      let newRequiredFields = addDependentState(existingRequiredFields, dependentFields);
      setRequiredFields(newRequiredFields);
    } else {
      let newRequiredFields = removeDependentStates(existingRequiredFields, dependentFields);
      setRequiredFields(newRequiredFields);
    }
  }, [failureForm.relayRoomOpened]);
  // }, [failureForm.status, failureForm.disconnectionMemoIssued, failureForm.relayRoomOpened])

  const getZoneList = useMemo(() => {
    let list = [];
    zone.forEach((zone) => {
      list.push({ id: zone, value: zone });
    });
    setFailureForm((prev) => {
      prev.zone = list.length > 0 ? list[0] : null;
    });
    return list;
  }, []);
  // const getUserRoles = useMemo(() => {
  //     let list = [];
  //     let url = `${APP_BASE_URL}${GET_USER_ROLES}`;
  //     let params = {}
  //     // if (failureForm?.customerId) {
  //     //     params = {
  //     //         customerIds: failureForm.customerId.id
  //     //     }
  //     // }
  //     axios.get(url, { params }).then((res) => {
  //         // const RESPONSE = res.data.data
  //         // console.log('user RESPONSE', RESPONSE)
  //         Object.entries(res.data.data).forEach(([key, value]) => {
  //             list.push({ id: key, value: value });
  //         });
  //     });
  //     return list;
  // }, []);
  const getUsersList = useMemo(() => {
    if (failureForm.customerId) {
      let list = [];
      // let url = `${APP_BASE_URL}${GET_USER_LIST}`;
      let url = `${APP_BASE_URL}${GET_ALL_USER}`;
      let params = {
        customerIds: failureForm.customerId.id,
        roleIdList: allowedUserRoleIds.toString(),
      };
      axios.get(url, { params }).then((res) => {
        let USERS = res.data.data;
        USERS.forEach((user) => {
          list.push({ id: user.id, value: user.firstName + " " + user.lastName });
        });
      });
      return list;
    } else {
      return [];
    }
  }, [failureForm.customerId]);

  const getDivisionList = useMemo(() => {
    let list = [];
    if (failureForm.zone) {
      let divList = division[failureForm.zone.value];
      divList.forEach((division) => {
        list.push({ id: division, value: division });
      });
    }

    setFailureForm((prev) => {
      prev.division = list[0];
    });
    // if (failureForm.division && !hasDropdownCuurentValue(list, failureForm.division)) {
    //   setFailureForm((prev) => {
    //     prev.division = null;
    //   });
    // }

    return list;
  }, [failureForm.zone]);

  const getStationList = useMemo(() => {
    let list = [];
    if (failureForm.division) {
      let stnList = station[failureForm.division.value];
      stnList.forEach((stn) => {
        list.push({ id: customer_name_to_id[stn].toString(), value: stn });
      });
    }
    if (failureForm.customerId && !hasDropdownCuurentValue(list, failureForm.customerId)) {
      setFailureForm((prev) => {
        prev.customerId = null;
      });
    }

    return list;
  }, [failureForm.division]);

  const getCOFDropDowns = useMemo(() => {
    let COF_LIST = [];
    if (failureForm.department) {
      COF_LIST = FIXED_REACTIVE_DROPDOWNS_COF[failureForm.department.value];
    }
    if (failureForm.causeOfFailure && !hasDropdownCuurentValue(COF_LIST, failureForm.causeOfFailure)) {
      setFailureForm((prev) => {
        prev.causeOfFailure = null;
      });
    }

    return COF_LIST;
  }, [failureForm.department]);

  useEffect(() => {
    if (failureForm.deviceId) {
      let url = `${APP_BASE_URL}${GET_ASSETS}/${failureForm.deviceId.id}`;
      axios.get(url).then((res) => {
        let RESPONSE = res.data.data;
        let ADDITIONAL_INFO = RESPONSE.additionaldetail;

        setFailureForm((prev) => {
          prev.connected = ADDITIONAL_INFO.connected ?? "";
          prev.model = ADDITIONAL_INFO.model ?? "";
          prev.make = ADDITIONAL_INFO.make ?? "";
          prev.serialNumber = ADDITIONAL_INFO.serial ?? "";
        });
        setIsMakeModelExists(ADDITIONAL_INFO.serial ?? false);
      });
    } else {
      setFailureForm((prev) => {
        prev.connected = "";
        prev.model = "";
        prev.model = "";
        prev.serialNumber = "";
      });
    }
  }, [failureForm.deviceId]);

  useEffect(() => {
    if (failureForm.failureOn && failureForm.repairedOn) {
      let duration = getDurationInMinutes(failureForm.failureOn, failureForm.repairedOn);
      setFailureForm((prev) => {
        prev.failurDuration = duration;
      });
    } else {
      setFailureForm((prev) => {
        prev.failurDuration = "";
      });
    }
  }, [failureForm.failureOn, failureForm.repairedOn]);

  useEffect(() => {
    if (failureForm.relayRoomOpenTs && failureForm.relayRoomCloseTs) {
      let duration = getDurationInMinutes(failureForm.relayRoomOpenTs, failureForm.relayRoomCloseTs);
      setFailureForm((prev) => {
        prev.relayRoomOpenDuration = duration;
      });
    } else {
      setFailureForm((prev) => {
        prev.relayRoomOpenDuration = "";
      });
    }
  }, [failureForm.relayRoomOpenTs, failureForm.relayRoomCloseTs]);

  const getAffectedAssets = useCallback((affectedAssets) => {
    setFailureForm((prev) => {
      prev.affectedAssets = affectedAssets;
    });
  }, []);
  const getDetainedTrains = useCallback((detainedTrains) => {
    setFailureForm((prev) => {
      prev.detainedTrains = detainedTrains;
    });
  }, []);

  const validateFailureForm = (form) => {
    let isValid = true;
    let dateStates = [];
    Object.entries(failurStateToLabelMap).forEach((key, keyObj) => {
      if (keyObj.type === "time") {
        dateStates.push(key);
      }
    });
    // let dateStates = Object.keys(failurStateToLabelMap);

    requiredFields.forEach((reqField) => {
      if (dateStates.includes(reqField)) {
        if (!validationState[reqField]) {
          // console.log("sfsadfg", reqField, form[reqField], failureForm);
          isValid = !failureForm[reqField] ? false : true;
          setValidationState((prev) => {
            prev[reqField] = !failureForm[reqField] ? "Field is required" : "";
          });
        }
      } else {
        if (!form[reqField]) {
          isValid = false;
          // console.log("isONOTVALID", reqField);
          setValidationState((prev) => {
            prev[reqField] = "Field is required";
          });
        } else {
          setValidationState((prev) => {
            prev[reqField] = "";
          });
        }
      }
    });
    let _validationState = { ...validationState, autoCheck: "" };
    Object.values(_validationState).forEach((errorText) => {
      if (errorText) {
        isValid = false;
      }
    });
    return isValid;
  };

  const handleSubmit = () => {
    let url = `${APP_BASE_URL}${SFR_API}`;
    let apiRequest = axios.post;
    let failureReportApiStatus = {
      severity: "success",
      msg: "Submitted Succesfully",
    };
    if (isEdit) {
      // url.log('failureForm in edit', failureForm)
      url = `${APP_BASE_URL}${SFR_API}/${failureForm.id}`;
      apiRequest = axios.put;
      failureReportApiStatus = {
        severity: "success",
        msg: "Updated Succesfully",
      };
    }

    let data = getDesiredFormat(failureForm);
    apiRequest(url, data)
      .then((res) => {
        localStorage.setItem("failureReportApiStatus", JSON.stringify(failureReportApiStatus));
      })
      .catch((err) => {
        const errMsg = err?.response?.data?.error?.message;
        failureReportApiStatus = {
          severity: "error",
          msg: errMsg,
        };
        localStorage.setItem("failureReportApiStatus", JSON.stringify(failureReportApiStatus));
      })
      .then(() => {
        navigate("/failure-incidences");
      });
  };
  const getMaxRange = (type, state) => {
    const [_, maxRangeArray] = getMinMaxRangeOfDate(type, state);
    let maxRange = null;
    let _relatedState = null;
    for (const relatedState of maxRangeArray) {
      if (failureForm[relatedState]) {
        maxRange = dayjs(new Date(failureForm[relatedState]));
        _relatedState = relatedState;
        break;
      }
    }
    return { maxRange: maxRange, relatedState: _relatedState };
  };

  const getRangeAndError = (type, state) => {
    const [minRangeArray, maxRangeArray] = getMinMaxRangeOfDate(type, state);
    let maxRange = null;
    let minRange = null;
    let minRangeState = null;
    let maxRangeState = null;
    for (const relatedState of maxRangeArray) {
      if (failureForm[relatedState]) {
        maxRange = failureForm[relatedState];
        maxRangeState = relatedState;
      }
    }
    for (const relatedState of minRangeArray) {
      if (failureForm[relatedState]) {
        minRange = failureForm[relatedState];
        minRangeState = relatedState;
      }
    }
    return {
      min: minRange ? { ts: minRange, errState: minRangeState } : null,
      max: maxRange ? { ts: maxRange, errState: maxRangeState } : null,
    };
  };
  const getMinRange = (type, state) => {
    const [minRangeArray, _] = getMinMaxRangeOfDate(type, state);
    let minRange = null;
    for (const relatedState of minRangeArray) {
      if (failureForm[relatedState]) {
        minRange = dayjs(new Date(failureForm[relatedState]));
        break;
      }
    }
    return minRange;
  };
  const handleConfirmPopup = () => {
    setValidationState((prev) => {
      prev.autoCheck = true;
    });
    if (validateFailureForm(failureForm)) {
      setConfirmationModal((prev) => {
        prev.open = true;
        prev.message = "Submit Form";
        prev.des = "Do you want to submit the form ?";
      });
    } else {
    }
  };

  const checkDateValidation = (rangeError, currentTs, currentState) => {
    const { min, max } = rangeError;
    let errorText = "";
    if (min) {
      let { ts, errState } = min;
      if (currentTs < ts) {
        errorText = "Value can not be less than " + failurStateToLabelMap[errState]?.label;
      }
    }
    if (max) {
      let { ts, errState } = max;
      if (currentTs > ts) {
        errorText = "Value can not be greater than " + failurStateToLabelMap[errState]?.label;
      }
    }
    setValidationState((prev) => {
      prev[currentState] = errorText;
    });
  };
  return (
    <form className="sfr-form-container">
      {confirmationModal.open && (
        <ConfirmationModal
          open={confirmationModal.open}
          onClose={() => {
            setConfirmationModal(initialConfirmationModal);
          }}
          onAction={(confirmation) => {
            if (confirmation) {
              handleSubmit();
            }
            setConfirmationModal(initialConfirmationModal);
          }}
          message={confirmationModal.message}
          des={confirmationModal.des}
        />
      )}
      <div className="sfr-form">
        {shouldFieldShouldBeShownForRole(USER_ROLE, "zone") && (
          <Autocomplete
            className="form-input autocomplete"
            size="small"
            value={failureForm.zone ?? null}
            onChange={(event, newValue) => {
              handleChange("zone", newValue);
            }}
            isOptionEqualToValue={(option, value) => option.id === value.id}
            options={getZoneList}
            getOptionLabel={(params) => {
              return params.value;
            }}
            // required={requiredFields.includes('zone')}

            renderInput={(params) => (
              <TextField
                size="small"
                error={validationState?.zone}
                helperText={validationState?.zone}
                {...params}
                label={"Division" + (requiredFields.includes("zone") ? "*" : "")}
                placeholder="Select Division"
              />
            )}
            // disabled={true}
          />
        )}
        {shouldFieldShouldBeShownForRole(USER_ROLE, "division") && (
          <Autocomplete
            size="small"
            className="form-input autocomplete"
            value={failureForm.division ?? null}
            isOptionEqualToValue={(option, value) => option.id === value.id}
            onChange={(event, newValue) => {
              handleChange("division", newValue);
            }}
            options={getDivisionList}
            getOptionLabel={(params) => {
              return params.value;
            }}
            // disabled
            renderInput={(params) => (
              <TextField
                error={validationState?.division}
                helperText={validationState?.division}
                size="small"
                {...params}
                label={"Section" + (requiredFields.includes("division") ? "*" : "")}
                placeholder="Select Section"
              />
            )}
          />
        )}

        {shouldFieldShouldBeShownForRole(USER_ROLE, "customerId") && (
          <Autocomplete
            size="small"
            className="form-input autocomplete"
            value={failureForm.customerId ?? null}
            isOptionEqualToValue={(option, value) => option.id === value.id}
            onChange={(event, newValue) => {
              handleChange("customerId", newValue);
            }}
            options={getStationList}
            getOptionLabel={(params) => {
              return params.value;
            }}
            renderInput={(params) => (
              <TextField
                size="small"
                {...params}
                label={"Station" + (requiredFields.includes("division") ? "*" : "")}
                error={validationState?.customerId}
                helperText={validationState?.customerId}
                placeholder="Select station"
              />
            )}
          />
        )}
        {shouldFieldShouldBeShownForRole(USER_ROLE, "failureEntryNo") && (
          <TextField
            className="form-input textfield"
            value={failureForm.failureEntryNo ?? ""}
            onChange={(e) => {
              handleChange("failureEntryNo", e.target.value);
            }}
            size="small"
            label={"Diary/Failure Number" + (requiredFields.includes("failureEntryNo") ? "*" : "")}
            error={validationState?.failureEntryNo}
            helperText={validationState?.failureEntryNo}
            placeholder="Diary/Failure Number"
            // disabled={true}
          />
        )}

        {shouldFieldShouldBeShownForRole(USER_ROLE, "department") && (
          <Autocomplete
            size="small"
            className="form-input autocomplete"
            value={failureForm.department ?? null}
            isOptionEqualToValue={(option, value) => option.id === value.id}
            onChange={(event, newValue) => {
              handleChange("department", newValue);
            }}
            options={FIXED_DROPDOWNS.department}
            getOptionLabel={(params) => {
              return params.value;
            }}
            renderInput={(params) => (
              <TextField
                size="small"
                {...params}
                label={"Branch" + (requiredFields.includes("department") ? "*" : "")}
                error={validationState?.department}
                helperText={validationState?.department}
                placeholder="Select Branch"
              />
            )}
          />
        )}

        {shouldFieldShouldBeShownForRole(USER_ROLE, "causeOfFailure") &&
          (getCOFDropDowns.length == 0 ? (
            <TextField
              className="form-input textfield"
              value={failureForm?.causeOfFailure?.value ?? ""}
              onChange={(e) => {
                handleChange("causeOfFailure", { id: e.target.value, value: e.target.value });
              }}
              size="small"
              label={"Cause Of Failure" + (requiredFields.includes("causeOfFailure") ? "*" : "")}
              error={validationState?.causeOfFailure}
              helperText={validationState?.causeOfFailure}
              placeholder="Cause Of Failure"
            />
          ) : (
            <Autocomplete
              size="small"
              className="form-input autocomplete"
              value={failureForm.causeOfFailure ?? null}
              isOptionEqualToValue={(option, value) => option.id === value.id}
              onChange={(event, newValue) => {
                handleChange("causeOfFailure", newValue);
              }}
              options={getCOFDropDowns}
              getOptionLabel={(params) => {
                return params.value;
              }}
              renderInput={(params) => (
                <TextField
                  size="small"
                  {...params}
                  label={"Cause Of Failure" + (requiredFields.includes("causeOfFailure") ? "*" : "")}
                  error={validationState?.causeOfFailure}
                  helperText={validationState?.causeOfFailure}
                  placeholder="Select Cause Of Failure"
                />
              )}
            />
          ))}

        {/* {shouldFieldShouldBeShownForRole(USER_ROLE, "uimsNumber") && (
          <TextField
            className="form-input textfield"
            value={failureForm.uimsNumber ?? ""}
            onChange={(e) => {
              handleChange("uimsNumber", e.target.value);
            }}
            size="small"
            label={"UIMS Number" + (requiredFields.includes("uimsNumber") ? "*" : "")}
            error={validationState?.uimsNumber}
            helperText={validationState?.uimsNumber}
            placeholder="Failure Entry No"
          />
        )} */}
        {shouldFieldShouldBeShownForRole(USER_ROLE, "assetType") && (
          <Autocomplete
            size="small"
            className="form-input autocomplete"
            value={failureForm.assetType ?? null}
            onChange={(event, newValue) => {
              handleChange("assetType", newValue);
            }}
            isOptionEqualToValue={(option, value) => option.id === value.id}
            options={gearTypesList}
            getOptionLabel={(params) => {
              return params.value;
            }}
            renderInput={(params) => (
              <TextField
                size="small"
                {...params}
                label={"Asset Type" + (requiredFields.includes("assetType") ? "*" : "")}
                error={validationState?.assetType}
                helperText={validationState?.assetType}
                placeholder="Select Asset Type"
              />
            )}
          />
        )}
        {shouldFieldShouldBeShownForRole(USER_ROLE, "deviceId") && (
          <Autocomplete
            size="small"
            className="form-input autocomplete"
            value={failureForm.deviceId ?? null}
            onChange={(event, newValue) => {
              handleChange("deviceId", newValue);
            }}
            isOptionEqualToValue={(option, value) => option.id === value.id}
            options={deviceNamesList}
            getOptionLabel={(params) => {
              return params.value;
            }}
            renderInput={(params) => (
              <TextField
                size="small"
                {...params}
                label={"Asset Name" + (requiredFields.includes("deviceId") ? "*" : "")}
                error={validationState?.deviceId}
                helperText={validationState?.deviceId}
                placeholder="Select Asset Name"
              />
            )}
          />
        )}
        {shouldFieldShouldBeShownForRole(USER_ROLE, "connected") && (
          <TextField
            className="form-input textfield disabledField"
            value={failureForm.connected ?? ""}
            size="small"
            label="Connected To"
            disabled
          />
        )}
        {shouldFieldShouldBeShownForRole(USER_ROLE, "make") && (
          <TextField
            className="form-input textfield disabledField"
            value={failureForm.make ?? ""}
            size="small"
            label="Make"
            disabled
          />
        )}
        {shouldFieldShouldBeShownForRole(USER_ROLE, "model") && (
          <TextField
            className="form-input textfield disabledField"
            value={failureForm.model ?? ""}
            size="small"
            label="Model"
            disabled
          />
        )}
        {shouldFieldShouldBeShownForRole(USER_ROLE, "serialNumber") && (
          <TextField
            className="form-input textfield disabledField"
            value={failureForm.serialNumber ?? ""}
            onChange={(e) => {
              handleChange("serialNumber", e.target.value);
            }}
            size="small"
            label="Serial Number"
            disabled={isMakeModelExists}
          />
        )}
        {shouldFieldShouldBeShownForRole(USER_ROLE, "failureOn") && (
          <Autocomplete
            size="small"
            className="form-input autocomplete"
            value={failureForm.infoReceivedBy ?? null}
            onChange={(event, newValue) => {
              handleChange("infoReceivedBy", newValue);
            }}
            isOptionEqualToValue={(option, value) => option.id === value.id}
            options={UESR_ROLE_DROPDOWNS}
            getOptionLabel={(params) => {
              return params.value;
            }}
            renderInput={(params) => (
              <TextField
                size="small"
                {...params}
                label={"Information Received By" + (requiredFields.includes("infoReceivedBy") ? "*" : "")}
                error={validationState?.infoReceivedBy}
                helperText={validationState?.infoReceivedBy}
                placeholder="Select role"
              />
            )}
          />
        )}

        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="en-gb">
          {shouldFieldShouldBeShownForRole(USER_ROLE, "failureOn") && (
            <DateTimePicker
              className="form-input dateTimeField"
              label={"Failure On" + (requiredFields.includes("failureOn") ? "*" : "")}
              value={failureForm.failureOn ?? null}
              onChange={(newValue) => {
                if (Date.parse(newValue && newValue["$d"])) {
                  let ts = newValue["$d"].getTime();
                  let rangeErrors = getRangeAndError("failure", "failureOn");
                  checkDateValidation(rangeErrors, ts, "failureOn");
                  handleChange("failureOn", ts);
                } else {
                  if (newValue === null) {
                    handleChange("failureOn", newValue);
                  }
                }
              }}
              renderInput={(params) => (
                <TextField
                  size="small"
                  {...params}
                  error={validationState?.failureOn}
                  helperText={validationState?.failureOn}
                  type="datetime-local"
                />
              )}
            />
          )}

          {shouldFieldShouldBeShownForRole(USER_ROLE, "infoReceivedTs") && (
            <DateTimePicker
              className="form-input dateTimeField"
              label={"information Received At" + (requiredFields.includes("infoReceivedTs") ? "*" : "")}
              value={failureForm.infoReceivedTs ?? null}
              onChange={(newValue) => {
                if (Date.parse(newValue && newValue["$d"])) {
                  let ts = newValue["$d"].getTime();
                  let rangeErrors = getRangeAndError("failure", "infoReceivedTs");
                  checkDateValidation(rangeErrors, ts, "infoReceivedTs");
                  handleChange("infoReceivedTs", ts);
                } else {
                  if (newValue === null) {
                    handleChange("infoReceivedTs", newValue);
                  }
                }
              }}
              renderInput={(params) => (
                <TextField
                  size="small"
                  {...params}
                  error={validationState?.infoReceivedTs}
                  helperText={validationState?.infoReceivedTs}
                  type="datetime-local"
                />
              )}
            />
          )}

          {shouldFieldShouldBeShownForRole(USER_ROLE, "failureAttendedTs") && (
            <DateTimePicker
              className="form-input dateTimeField"
              label={"Failure Attended at Hrs" + (requiredFields.includes("failureAttendedTs") ? "*" : "")}
              value={failureForm.failureAttendedTs ?? null}
              onChange={(newValue) => {
                if (Date.parse(newValue && newValue["$d"])) {
                  let ts = newValue["$d"].getTime();
                  let rangeErrors = getRangeAndError("failure", "failureAttendedTs");
                  checkDateValidation(rangeErrors, ts, "failureAttendedTs");
                  handleChange("failureAttendedTs", ts);
                } else {
                  if (newValue === null) {
                    handleChange("failureAttendedTs", newValue);
                  }
                }
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  error={validationState?.failureAttendedTs}
                  helperText={validationState?.failureAttendedTs}
                  size="small"
                />
              )}
            />
          )}
        </LocalizationProvider>
        {shouldFieldShouldBeShownForRole(USER_ROLE, "status") && (
          <Autocomplete
            size="small"
            className="form-input autocomplete"
            value={failureForm.status ?? null}
            isOptionEqualToValue={(option, value) => option.id === value.id}
            onChange={(event, newValue) => {
              handleChange("status", newValue);
            }}
            options={rectificationStatusDropdowns}
            getOptionLabel={(params) => {
              return params.value;
            }}
            renderInput={(params) => (
              <TextField
                size="small"
                {...params}
                label={"Rectification Status" + (requiredFields.includes("status") ? "*" : "")}
                error={validationState?.status}
                helperText={validationState?.status}
                placeholder="Rectification Status"
              />
            )}
          />
        )}

        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="en-gb">
          {/* <DateTimePicker
                        className="form-input dateTimeField"
                        label={"Failure Attended at Hrs" + (requiredFields.includes('failureAttendedTs') ? '*' : "")}
                        value={failureForm.failureAttendedTs ?? null}
                        onChange={(newValue) => {
                            if (Date.parse(newValue && newValue["$d"])) {
                                let ts = newValue["$d"].getTime();
                                handleChange("failureAttendedTs", ts);
                            } else {
                                if (newValue === null) {
                                    handleChange("failureAttendedTs", newValue);
                                }
                            }
                        }}
                        renderInput={(params) => <TextField {...params} error={validationState?.failureAttendedTs} helperText={validationState?.failureAttendedTs} size="small" />}
                    /> */}
          {shouldFieldShouldBeShownForRole(USER_ROLE, "repairrepairedOnedBy") &&
            failureForm.status &&
            (failureForm.status.value === "REPAIRED" || failureForm.status.value === "CLOSE") && (
              <DateTimePicker
                className="form-input dateTimeField"
                label={"Rectification On" + (requiredFields.includes("repairedOn") ? "*" : "")}
                value={failureForm.repairedOn ?? null}
                onChange={(newValue) => {
                  if (Date.parse(newValue && newValue["$d"])) {
                    let ts = newValue["$d"].getTime();
                    let rangeErrors = getRangeAndError("failure", "repairedOn");
                    checkDateValidation(rangeErrors, ts, "repairedOn");
                    handleChange("repairedOn", ts);
                  } else {
                    if (newValue === null) {
                      handleChange("repairedOn", newValue);
                    }
                  }
                }}
                renderInput={(params) => (
                  <TextField
                    size="small"
                    {...params}
                    error={validationState?.repairedOn}
                    helperText={validationState?.repairedOn}
                    type="datetime-local"
                  />
                )}
              />
            )}
        </LocalizationProvider>

        {failureForm.status && (failureForm.status.value === "REPAIRED" || failureForm.status.value === "CLOSE") && (
          <>
            {/* <TextField
                            value={failureForm.repairedBy}
                            className="form-input textfield"
                            size="small"
                            onChange={(e) => {
                                handleChange("repairedBy", e.target.value);
                            }}
                            placeholder="Rectification By"
                            label="Rectification By"
                        /> */}
            {shouldFieldShouldBeShownForRole(USER_ROLE, "repairedBy") && (
              <Autocomplete
                size="small"
                className="form-input autocomplete"
                value={failureForm.repairedBy ?? null}
                isOptionEqualToValue={(option, value) => option.id === value.id}
                onChange={(event, newValue) => {
                  handleChange("repairedBy", newValue);
                }}
                options={getUsersList}
                getOptionLabel={(params) => {
                  return params.value;
                }}
                renderInput={(params) => (
                  <TextField
                    size="small"
                    {...params}
                    label={"Rectification By" + (requiredFields.includes("repairedBy") ? "*" : "")}
                    error={validationState?.repairedBy}
                    helperText={validationState?.repairedBy}
                    placeholder="Rectification By"
                  />
                )}
              />
            )}

            {shouldFieldShouldBeShownForRole(USER_ROLE, "failurDuration") && (
              <TextField
                className="form-input textfield disabledField"
                value={failureForm.failurDuration ?? ""}
                size="small"
                label="Failure Duration (in Minutes)"
                disabled
                // placeholder="Failure Entry No"
              />
            )}
          </>
        )}
        {shouldFieldShouldBeShownForRole(USER_ROLE, "disconnectionMemoIssued") && (
          <Autocomplete
            size="small"
            className="form-input autocomplete"
            value={failureForm.disconnectionMemoIssued ?? null}
            isOptionEqualToValue={(option, value) => option.id === value.id}
            onChange={(event, newValue) => {
              handleChange("disconnectionMemoIssued", newValue);
            }}
            options={disconnectionMemoIssuedDropdowns}
            getOptionLabel={(params) => {
              return params.value;
            }}
            renderInput={(params) => (
              <TextField
                size="small"
                {...params}
                label={
                  "Disconnection Memo Issued to Rectify the Failure" +
                  (requiredFields.includes("disconnectionMemoIssued") ? "*" : "")
                }
                error={validationState?.disconnectionMemoIssued}
                helperText={validationState?.disconnectionMemoIssued}
                placeholder="Disconnection Memo Issued to Rectify the Failure"
              />
            )}
          />
        )}
        {failureForm.disconnectionMemoIssued && failureForm.disconnectionMemoIssued.value === "YES" && (
          <>
            {shouldFieldShouldBeShownForRole(USER_ROLE, "disconnectionMemoReqNumber") && (
              <TextField
                className="form-input textfield"
                value={failureForm.disconnectionMemoReqNumber ?? ""}
                size="small"
                onChange={(e) => {
                  handleChange("disconnectionMemoReqNumber", e.target.value);
                }}
                placeholder="Disconnection Memo Request Number"
                label={
                  "Disconnection Memo Request Number" +
                  (requiredFields.includes("disconnectionMemoReqNumber") ? "*" : "")
                }
                error={validationState?.disconnectionMemoReqNumber}
                helperText={validationState?.disconnectionMemoReqNumber}
              />
            )}
            {shouldFieldShouldBeShownForRole(USER_ROLE, "disconnectionMemoTimeOfferd") && (
              <TextField
                className="form-input textfield"
                value={failureForm.disconnectionMemoTimeOfferd ?? ""}
                size="small"
                // type="number"
                onChange={(e) => {
                  const regex = /^\d*\.?\d{0,}$/;
                  let inputValue = e.target.value;
                  if (regex.test(inputValue)) {
                    handleChange("disconnectionMemoTimeOfferd", inputValue);
                  }
                }}
                placeholder="Time Requested (In Minutes)"
                label={
                  "Time Requested (In Minutes)" + (requiredFields.includes("disconnectionMemoTimeOfferd") ? "*" : "")
                }
                error={validationState?.disconnectionMemoTimeOfferd}
                helperText={validationState?.disconnectionMemoTimeOfferd}
              />
            )}
            {shouldFieldShouldBeShownForRole(USER_ROLE, "disconnectionMemoTimeAccepted") && (
              <TextField
                className="form-input textfield"
                value={failureForm.disconnectionMemoTimeAccepted ?? ""}
                size="small"
                onChange={(e) => {
                  const regex = /^\d*\.?\d{0,}$/;
                  let inputValue = e.target.value;
                  if (regex.test(inputValue)) {
                    handleChange("disconnectionMemoTimeAccepted", inputValue);
                  }
                }}
                placeholder="Time Accepted  (In Minutes)"
                label={
                  "Time Accepted (In Minutes)" + (requiredFields.includes("disconnectionMemoTimeAccepted") ? "*" : "")
                }
                error={validationState?.disconnectionMemoTimeAccepted}
                helperText={validationState?.disconnectionMemoTimeAccepted}
              />
            )}

            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="en-gb">
              {shouldFieldShouldBeShownForRole(USER_ROLE, "gearDisconnectTime") && (
                <DateTimePicker
                  className="form-input dateTimeField"
                  label={"Time of Gear Disconnect" + (requiredFields.includes("gearDisconnectTime") ? "*" : "")}
                  value={failureForm.gearDisconnectTime ?? null}
                  onChange={(newValue) => {
                    if (Date.parse(newValue && newValue["$d"])) {
                      let ts = newValue["$d"].getTime();
                      let rangeErrors = getRangeAndError("disconnectionMemo", "gearDisconnectTime");
                      checkDateValidation(rangeErrors, ts, "gearDisconnectTime");
                      handleChange("gearDisconnectTime", ts);
                    } else {
                      if (newValue === null) {
                        handleChange("gearDisconnectTime", newValue);
                      }
                    }
                  }}
                  renderInput={(params) => (
                    <TextField
                      size="small"
                      {...params}
                      error={validationState?.gearDisconnectTime}
                      helperText={validationState?.gearDisconnectTime}
                      type="datetime-local"
                    />
                  )}
                />
              )}

              {shouldFieldShouldBeShownForRole(USER_ROLE, "gearReconnectionTime") && (
                <DateTimePicker
                  className="form-input dateTimeField"
                  label={"Time of Gear Reconnect" + (requiredFields.includes("gearReconnectionTime") ? "*" : "")}
                  value={failureForm.gearReconnectionTime ?? null}
                  onChange={(newValue) => {
                    if (Date.parse(newValue && newValue["$d"])) {
                      let ts = newValue["$d"].getTime();
                      let rangeErrors = getRangeAndError("disconnectionMemo", "gearReconnectionTime");
                      checkDateValidation(rangeErrors, ts, "gearReconnectionTime");
                      handleChange("gearReconnectionTime", ts);
                    } else {
                      if (newValue === null) {
                        handleChange("gearReconnectionTime", newValue);
                      }
                    }
                  }}
                  renderInput={(params) => (
                    <TextField
                      size="small"
                      {...params}
                      error={validationState?.gearReconnectionTime}
                      helperText={validationState?.gearReconnectionTime}
                      type="datetime-local"
                    />
                  )}
                />
              )}
            </LocalizationProvider>
          </>
        )}
        {shouldFieldShouldBeShownForRole(USER_ROLE, "relayRoomOpened") && (
          <Autocomplete
            size="small"
            className="form-input autocomplete"
            value={failureForm.relayRoomOpened ?? null}
            isOptionEqualToValue={(option, value) => option.id === value.id}
            onChange={(event, newValue) => {
              handleChange("relayRoomOpened", newValue);
            }}
            options={relayRoomOpenDropdowns}
            getOptionLabel={(params) => {
              return params.value;
            }}
            renderInput={(params) => (
              <TextField
                className="form-input textfield"
                size="small"
                {...params}
                label={"Relay Room Open" + (requiredFields.includes("relayRoomOpened") ? "*" : "")}
                error={validationState?.relayRoomOpened}
                helperText={validationState?.relayRoomOpened}
                placeholder="Relay Room Open"
              />
            )}
          />
        )}

        {failureForm.relayRoomOpened && failureForm.relayRoomOpened.value === "YES" && (
          <>
            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="en-gb">
              {shouldFieldShouldBeShownForRole(USER_ROLE, "relayRoomOpenTs") && (
                <DateTimePicker
                  className="form-input dateTimeField"
                  label={"Relay Room Open Timing" + (requiredFields.includes("relayRoomOpenTs") ? "*" : "")}
                  value={failureForm.relayRoomOpenTs ?? null}
                  onChange={(newValue) => {
                    if (Date.parse(newValue && newValue["$d"])) {
                      let ts = newValue["$d"].getTime();
                      let rangeErrors = getRangeAndError("relayRoom", "relayRoomOpenTs");
                      checkDateValidation(rangeErrors, ts, "relayRoomOpenTs");
                      handleChange("relayRoomOpenTs", ts);
                    } else {
                      if (newValue === null) {
                        handleChange("relayRoomOpenTs", newValue);
                      }
                    }
                  }}
                  renderInput={(params) => (
                    <TextField
                      size="small"
                      {...params}
                      error={validationState?.relayRoomOpenTs}
                      helperText={validationState?.relayRoomOpenTs}
                      type="datetime-local"
                    />
                  )}
                />
              )}

              {shouldFieldShouldBeShownForRole(USER_ROLE, "relayRoomOpenTs") && (
                <DateTimePicker
                  className="form-input dateTimeField"
                  label={"Relay Room Closed Timing" + (requiredFields.includes("relayRoomCloseTs") ? "*" : "")}
                  value={failureForm.relayRoomCloseTs ?? null}
                  onChange={(newValue) => {
                    if (Date.parse(newValue && newValue["$d"])) {
                      let ts = newValue["$d"].getTime();
                      let rangeErrors = getRangeAndError("relayRoom", "relayRoomCloseTs");
                      checkDateValidation(rangeErrors, ts, "relayRoomCloseTs");
                      handleChange("relayRoomCloseTs", ts);
                    } else {
                      if (newValue === null) {
                        handleChange("relayRoomCloseTs", newValue);
                      }
                    }
                  }}
                  maxDateTime={getMaxRange("relayRoom", "relayRoomCloseTs")}
                  minDateTime={getMinRange("relayRoom", "relayRoomCloseTs")}
                  renderInput={(params) => (
                    <TextField
                      size="small"
                      {...params}
                      error={validationState?.relayRoomCloseTs}
                      helperText={validationState?.relayRoomCloseTs}
                      type="datetime-local"
                    />
                  )}
                />
              )}
            </LocalizationProvider>
            {shouldFieldShouldBeShownForRole(USER_ROLE, "relayRoomOpenDuration") && (
              <TextField
                className="form-input textfield disabledField"
                value={failureForm.relayRoomOpenDuration ?? ""}
                size="small"
                label="Realy Room Opened Duration(In Minutes)"
                disabled
                // placeholder="Failure Entry No"
              />
            )}
          </>
        )}
        {/* <InputLabel>Action Performed</InputLabel>
                <StyledTextarea
                    aria-label="minimum height"
                    minRows={3}
                    placeholder="Action Performed"
                /> */}

        {shouldFieldShouldBeShownForRole(USER_ROLE, "actionPerformed") && (
          <TextField
            className="form-input textfield"
            value={failureForm.actionPerformed ?? ""}
            onChange={(e) => {
              handleChange("actionPerformed", e.target.value);
            }}
            size="small"
            label={"Action Performed" + (requiredFields.includes("actionPerformed") ? "*" : "")}
            error={validationState?.actionPerformed}
            helperText={validationState?.actionPerformed}
            placeholder="Action Performed"
          />
        )}
        {shouldFieldShouldBeShownForRole(USER_ROLE, "remarks") && (
          <TextField
            className="form-input textfield"
            value={failureForm.remarks ?? ""}
            onChange={(e) => {
              handleChange("remarks", e.target.value);
            }}
            size="small"
            label="Remarks"
            placeholder="Remarks"
          />
        )}
      </div>
      {shouldFieldShouldBeShownForRole(USER_ROLE, "affectedAssets") && (
        <AffectedGearTypes
          initialAffectedAssets={failureForm?.affectedAssets ?? INITIAL_AFFECTED_ASSETS}
          getAffectedAssets={getAffectedAssets}
          selectedStation={failureForm.customerId ? failureForm.customerId : null}
        />
      )}
      {shouldFieldShouldBeShownForRole(USER_ROLE, "detainedTrains") && (
        <DetainedTrains
          initialDetainedTrains={failureForm?.detainedTrains ?? INITIAL_DETAINED_TRAINS}
          getDetainedTrains={getDetainedTrains}
        />
      )}

      <div className="sfr-form-actions">
        <Button variant="contained" onClick={() => handleConfirmPopup()}>
          {isEdit ? "Update" : "Submit"}
        </Button>
        {/* <Button variant="outlined" onClick={handleClearForm()}>Clear</Button> */}
      </div>
    </form>
  );
}

export default SFRFORM_Component;
